export default __webpack_public_path__ + "static/1066-bb23a718b5769fde0764c2075b1d5241.gif";